<template>
  <div class="default-modal">
    <el-dialog
      width="50%"
      top="15vh"
      v-model="exportReportsDialogVisible"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part">
          <h3>CRITICAL CASES REPORT</h3>
        </div>

        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>

      <div class="selected-string" v-if="selectedHospitalName">
        <h3>
          Selected Ordering Facility :
          <span class="value">{{ selectedHospitalName }}</span>
        </h3>
      </div>
      <div class="selected-string" v-if="fromDate">
        <h3>
          From Date :
          <span class="value">{{ fromDate }}</span>
        </h3>
      </div>
      <div class="selected-string" v-if="toDate">
        <h3>
          To Date :
          <span class="value">{{ toDate }}</span>
        </h3>
      </div>
      <div class="selected-string" v-if="filterValue">
        <h3>
          Filter :
          <span class="value">{{ filterValue === 'critical' ? 'Is Critical' : 'Resolved' }}</span>
        </h3>
      </div>
      <div class="selected-string" v-if="caseStatus">
        <h3>
          Case Status :
          <span class="value">{{ getStatusLabel(caseStatus) }}</span>
        </h3>
      </div>

      <div class="dialog-body">
        <div class="export-popup-body" v-loading="loading">
          <div class="select-fields">
            <el-checkbox-group v-model="activeFieldList">
              <ul class="select-fields-list">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in exportFields"
                  :key="index"
                >
                  <el-checkbox :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button
          class="cancel-button"
          @click="handleClear"
          :disabled="!activeFieldList.length"
        >CLEAR ALL</el-button>
        <el-button class="cancel-button" @click="handleCheckAllChange">SELECT ALL</el-button>
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button
          class="blue-save-button"
          @click="downloadCriticalCases"
          :loading="downloadLoading"
          :disabled="!activeFieldList.length"
        >
          DOWNLOAD
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

export default {
  props: {
    selectedHospitalName: {
      type: String,
      default: "",
    },
    fromDate: {
      type: String,
      default: "",
    },
    toDate: {
      type: String,
      default: "",
    },
    filterValue: {
      type: String,
      default: "",
    },
    caseStatus: {
      type: String,
      default: "",
    },
    exportParams: {
      type: Object,
      default: () => ({}),
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      exportReportsDialogVisible: true,
      loading: false,
      downloadLoading: false,
      activeFieldList: [],
      exportFields: [
        { label: "Accession ID", value: "accession_id" },
        { label: "Patient Name", value: "patient_name" },
        { label: "Ordering Facility", value: "facility_name" },
        { label: "Critical Values", value: "critical_values" },
        { label: "Comments", value: "comments" },
        { label: "Case Status", value: "case_status" },
        { label: "Message Sent", value: "is_client_message_sent" },
        { label: "Notes", value: "notes" },
        { label: "Created At", value: "created_at" },
      ],
    };
  },
  created() {
    // Select all by default
    this.activeFieldList = this.exportFields.map((field) => field.value);
  },
  methods: {
    getStatusLabel(status) {
      const statusMap = {
        ACTIVE: "Active",
        COMPLETE: "Finalized",
        TEST_REPORTS: "Processing",
        REJECTED: "Rejected",
        PENDING: "Pending",
      };
      return statusMap[status] || status;
    },
    handleClear() {
      this.activeFieldList = [];
    },
    handleCheckAllChange() {
      this.activeFieldList = this.exportFields.map((field) => field.value);
    },
    close() {
      this.exportReportsDialogVisible = false;
      this.$emit("close");
    },
    async downloadCriticalCases() {
      try {
        this.downloadLoading = true;
        let params = { ...this.exportParams };
        delete params.page;
        delete params.limit;
        params.include = this.activeFieldList.join(",");

        if (this.selectedRows && this.selectedRows.length > 0) {
          params.case_ids = this.selectedRows.map(row => row.id || row.case_id).filter(id => id).join(',');
        }

        const response = await axios.get(
          `${process.env.VUE_APP_BLOOD_INTERFACE}/critical-values/export`,
          {
            headers: {
              Authorization: `${process.env.VUE_APP_BLOOD_INTERFACE_ACCESS_TOKEN}`,
            },
            params: params,
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "critical-values-export.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        successNotification("Export successful");
        this.downloadLoading = false;
        this.close();
      } catch (error) {
        this.downloadLoading = false;
        errorNotification("Error while exporting critical values");
        console.log(error);
      }
    },
  },
};
</script>
